import { client } from '@/common-utils/libraries/axios/axios';
import DASHBOARD from '../apiUrls';
import POSTERMINAL_STATS_FIELDS from '../../fields/PosterminalStatsFields';

const mapResponseData = (responseData) => {
    const data = {
        [POSTERMINAL_STATS_FIELDS.ACTIVE_SUB_BLOCKED_POS_COUNT.key]: responseData[POSTERMINAL_STATS_FIELDS.ACTIVE_SUB_BLOCKED_POS_COUNT.key],
        [POSTERMINAL_STATS_FIELDS.ACTIVE_SUBSCRIPTIONS_TOTAL.key]: responseData[POSTERMINAL_STATS_FIELDS.ACTIVE_SUBSCRIPTIONS_TOTAL.key],
        // [POSTERMINAL_STATS_FIELDS.REMOTE_COLLECTION_24H_COUNT.key]: responseData[POSTERMINAL_STATS_FIELDS.REMOTE_COLLECTION_24H_COUNT.key],
        [POSTERMINAL_STATS_FIELDS.MANUFACTURER_BREAKDOWN.key]: responseData[POSTERMINAL_STATS_FIELDS.MANUFACTURER_BREAKDOWN.key],
        [POSTERMINAL_STATS_FIELDS.POS_STATUS_BREAKDOWN.key]: responseData[POSTERMINAL_STATS_FIELDS.POS_STATUS_BREAKDOWN.key],
        [POSTERMINAL_STATS_FIELDS.COMMUNICATION_MODE_BREAKDOWN.key]: responseData[POSTERMINAL_STATS_FIELDS.COMMUNICATION_MODE_BREAKDOWN.key],
        [POSTERMINAL_STATS_FIELDS.TOP5_WHITE_LABEL.key]: responseData[POSTERMINAL_STATS_FIELDS.TOP5_WHITE_LABEL.key],
        [POSTERMINAL_STATS_FIELDS.TOP5_MERCHANT.key]: responseData[POSTERMINAL_STATS_FIELDS.TOP5_MERCHANT.key],
        [POSTERMINAL_STATS_FIELDS.FLOP5_MERCHANT.key]: responseData[POSTERMINAL_STATS_FIELDS.FLOP5_MERCHANT.key],
        [POSTERMINAL_STATS_FIELDS.FLOP5_WHITE_LABEL.key]: responseData[POSTERMINAL_STATS_FIELDS.FLOP5_WHITE_LABEL.key]
    };
    return data;

};

const queryGetPosTerminalAndSubscriptionsStats = (enabled = true) => {
    return {
        queryKey: [DASHBOARD.POS_TERMINAL_AND_SUBSCRIPTIONS.queryKey],
        queryFn: async () => {
            const response = await client.get(DASHBOARD.POS_TERMINAL_AND_SUBSCRIPTIONS.url);
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetPosTerminalAndSubscriptionsStats;